var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "import-account-wrapper" }, [
    _c("div", { staticClass: "__title" }, [
      _vm._v(_vm._s(_vm.$t("mnemonic.record")))
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "note" }, [
      _vm._v(_vm._s(_vm.$t("mnemonic.prompt")))
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c(
        "span",
        { staticClass: "change __pointer", on: { click: _vm.change } },
        [_vm._v(_vm._s(_vm.$t("mnemonic.change", { len: _vm.len })))]
      ),
      _vm._v(" "),
      _c("img", {
        staticClass: "copy __pointer",
        attrs: { src: require("assets/imgs/copy_white.svg") },
        on: { click: _vm.copy }
      })
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "wrapper" },
      [
        _c("copy", { ref: "copyDome", staticClass: "copy-wrapper" }),
        _vm._v(" "),
        _vm._l(_vm.mnemonicList, function(item, index) {
          return _c(
            "span",
            {
              key: index,
              staticClass: "item",
              class: {
                "long-item": _vm.mnemonicList.length === 12
              }
            },
            [_vm._v("\n            " + _vm._s(item) + "\n        ")]
          )
        })
      ],
      2
    ),
    _vm._v(" "),
    _c("div", { staticClass: "__btn_list" }, [
      _c(
        "span",
        {
          staticClass: "__btn __btn_border __pointer",
          on: { click: _vm.goBack }
        },
        [_vm._v(_vm._s(_vm.$t("btn.back")))]
      ),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "__btn __btn_all_in __pointer",
          on: { click: _vm.login }
        },
        [
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.isLoading,
                  expression: "!isLoading"
                }
              ]
            },
            [_vm._v(_vm._s(_vm.$t("btn.submit")))]
          ),
          _vm._v(" "),
          _c("loading", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isLoading,
                expression: "isLoading"
              }
            ],
            attrs: { loadingType: "dot" }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }